import React from 'react';

import alarmIcon from 'assets/icons/raffledetails/alarm.png';

const Miss = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-neutral-900 p-3">
      <img src={alarmIcon.src} className="w-6" alt="" />
      <div className="text-base font-normal text-neutral-400">
        Raffle is over
      </div>
    </div>
  );
};

export default Miss;
